import { useAddDisplayWebContentToWorkflow } from './useAddDisplayWebContentToWorkflow';
import { useRemoveDisplayWebContentFromWorkflow } from './useRemoveDisplayWebContentFromWorkflow';
import { useGetDisplayWebContentSelector } from '../state/selectors/useGetDisplayWebContentSelector';
import { useGetTemplateSelector } from '../state/selectors/useGetTemplateSelector';
import { useIsInFlowSelector } from '../state/selectors/useIsInFlowSelector';
import { useSetTemplate } from '../state/actions/useSetTemplate';
import { useGetDisplaySegmentationSelector } from '../state/selectors/useGetDisplaySegmentationSelector';
import { useDisplaySaveSegmentation } from '../state/actions/useDisplaySaveSegmentation';
import { useSetDisplaySegmentationChosen } from '../state/actions/useSetDisplaySegmentationChosen';
import { useOnMessageDragged } from './useOnMessageDragged';
import { useOnMessageDragEnd } from './useOnMessageDragEnd';
import { useAddDisplayWebContent } from '../state/actions/useAddDisplayWebContent';
import { useGetControlGroupSelector } from '../state/selectors/useGetControlGroupSelector';
import { useGetControlGroupWeightSelector } from '../state/selectors/useGetControlGroupWeightSelector';
import { useSetControlGroup } from '../state/actions/useSetControlGroup';
import { useSetDisplayWebContenetName } from '../state/actions/useSetDisplayWebContenetName';
import { useNameSelector } from '../state/selectors/useNameSelector';

export const useDisplayWebContent = () => {
  const addToFlow = useAddDisplayWebContentToWorkflow();
  const removeFromFlow = useRemoveDisplayWebContentFromWorkflow();
  const onMessageDragged = useOnMessageDragged();
  const onMessageDragEnd = useOnMessageDragEnd();

  const getDisplayWebContent = useGetDisplayWebContentSelector();
  const getTemplate = useGetTemplateSelector();
  const isInFlow = useIsInFlowSelector();

  const setName = useSetDisplayWebContenetName();
  const getName = useNameSelector();

  const setTemplate = useSetTemplate();

  const setControlGroupMessages = useSetControlGroup();
  const getControlGroup = useGetControlGroupSelector();
  const getControlGroupWeight = useGetControlGroupWeightSelector();

  const getSegmentation = useGetDisplaySegmentationSelector();
  const setSegmentationChosen = useSetDisplaySegmentationChosen();
  const saveSegmentation = useDisplaySaveSegmentation();
  const addDisplayWebContent = useAddDisplayWebContent();

  return {
    addToFlow,
    removeFromFlow,
    onMessageDragged,
    onMessageDragEnd,

    getDisplayWebContent,
    getTemplate,
    isInFlow,

    setName,
    getName,
    setTemplate,

    getSegmentation,
    setSegmentationChosen,
    saveSegmentation,
    addDisplayWebContent,

    setControlGroupMessages,
    getControlGroup,
    getControlGroupWeight,
  };
};
